import React, { useEffect, useState } from 'react';

function TableDataValue({ value }) {
    const [displayValue, setDisplayValue] = useState('-');

    useEffect(() => {
        if (typeof value !== 'undefined') {
            setDisplayValue(value);
        }
    }, [value]);

    return <>{displayValue}</>;
}

export default TableDataValue;
